import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  children: React.ReactNode;
}

const Container = styled.div`
  width: 28px;
  height: 28px;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  border-radius: 50%;
  font-size: 15px;
  line-height: 30px;
  text-align: center;
  display: block;
  overflow: hidden;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;

const CircleBadge: React.FC<IProps> = ({ children }) => <Container>{children}</Container>;

export default CircleBadge;
